(function(window, document) {
  'use strict';

  mint.on('documentLoaded', function() {

    const mainNavigation = document.querySelector('.navigation--main');
    const mainNavigationInstance =  mint.components.navigation(mainNavigation, {});

    const offCanvasSwitch = document.querySelector('.page-header__offcanvas-switch');

    const isMobileEnabled = function() {
      if(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navigation-mobile-enabled')) === 1) {
        return true;
      }

      return false;
    };

    const isDesktopEnabled = function() {
      if(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navigation-desktop-enabled')) === 1) {
        return true;
      }

      return false;
    };

    // Zum Testen auskommentiert
    mainNavigation.addEventListener('navigation.link.mousemove', function(event) {
      if(isDesktopEnabled() === true) {
        event.detail.navigation.itemActivate(event.detail.groupItem, event.detail.item);
      }
    });

    mainNavigation.addEventListener('navigation.link.mouseout', function(event) {
      if(isDesktopEnabled() === true) {
        event.detail.navigation.itemDeactivate(event.detail.groupItem, event.detail.item);
      }
    });

    // Einzel-Events von Items / Links verarbeiten
    mainNavigation.querySelectorAll('.navigation__group-item').forEach(function(item) {
      const link = item.querySelector('.navigation-item');
      const groupContainerLv2 = item.querySelector('.navigation__group-container--lv2');
      const switchButton = item.querySelector('.navigation__group-switch');
      const closeButton = item.querySelector('.navigation__group-close');

      if(switchButton !== null) {
        const switchButtonInstance = mint.components.switchButton(switchButton, {
          durationCssVariable: '--navigation-transition-duration',
          activateCssClass: 'navigation__group-switch--activate',
          activeCssClass: 'navigation__group-switch--active',
          deactivateCssClass: 'navigation__group-switch--deactivate'
        });

        switchButton.addEventListener('switch-button.activate', function(event) {
          mainNavigationInstance.itemActivate(item, link);
        });

        switchButton.addEventListener('switch-button.deactivate', function(event) {
          mainNavigationInstance.itemDeactivate(item, link);
        });

        if(closeButton !== null) {
          closeButton.addEventListener('keydown', function(event) {
            if(event.code === 'Enter') {
              switchButtonInstance.deactivate();
              event.preventDefault();

              setTimeout(function() {
                switchButton.focus();
              }, 0);
            }
          });

          closeButton.addEventListener('click', function(event) {
            mainNavigationInstance.itemDeactivate(item, link, true);
          });
        }
      }

      link.addEventListener('click', function(event) {

        // gibt es ein Linkziel auf der Seite? -> dann springe es direkt an (animiert - 35 offset)
        let target = link.getAttribute('href');
        let timeout = 50;

        // anderes Timeout fuer Mobil -> Scroll-Lock muss abgewartet werden
        if(isMobileEnabled() === true) {
          timeout = parseInt(getComputedStyle(offCanvasSwitch).getPropertyValue('--switch-button-transition-duration')) + 50;
        }

        if(target.indexOf('#') === 0 && document.querySelector(target)) {
          setTimeout(function() {
            document.querySelector(target).scrollIntoView({
              behavior: 'smooth'
            });
          }, timeout);

          mainNavigationInstance.initializeForceDeactivate();
          mainNavigationInstance.deactivateAll();

          // falls man sich in der mobilen Navigation (Off-Canvas) befindet
          mint.fireEvent('switch-button.fire.deactivate', null, offCanvasSwitch);
        }
      });

      item.addEventListener('navigation.item.activate', function(event) {
        link.classList.add('navigation-item--activate');

        if(switchButton !== null) {
          switchButton.classList.add('navigation__group-switch--activate');
        }

        if(groupContainerLv2 !== null) {
          groupContainerLv2.classList.add('navigation__group-container--lv2-activate');

          if(isMobileEnabled() === true) {
            item.style.maxHeight = link.offsetHeight + 'px';

            setTimeout(function() {
              item.style.maxHeight = (groupContainerLv2.offsetHeight + link.offsetHeight) + 'px';
            }, 0);
          }
        }
      });

      item.addEventListener('navigation.item.activated', function(event) {
        link.classList.add('navigation-item--active');
        link.classList.remove('navigation-item--activate');

        if(switchButton !== null) {
          switchButton.classList.add('navigation__group-switch--active');
          switchButton.classList.remove('navigation__group-switch--activate');
        }

        if(groupContainerLv2 !== null) {
          groupContainerLv2.classList.add('navigation__group-container--lv2-active');
          groupContainerLv2.classList.remove('navigation__group-container--lv2-activate');
          item.removeAttribute('style'); // Hoehe aus der Animation wieder entfernen
        }
      });

      item.addEventListener('navigation.item.deactivate', function(event) {
        link.classList.add('navigation-item--deactivate');
        link.classList.remove('navigation-item--active');
        link.classList.remove('navigation-item--activate');

        if(switchButton !== null) {
          switchButton.classList.add('navigation__group-switch--deactivate');
          switchButton.classList.remove('navigation__group-switch--active');
          switchButton.classList.remove('navigation__group-switch--activate');
        }

        if(groupContainerLv2 !== null) {
          groupContainerLv2.classList.add('navigation__group-container--lv2-deactivate');
          groupContainerLv2.classList.remove('navigation__group-container--lv2-active');
          groupContainerLv2.classList.remove('navigation__group-container--lv2-activate');

          if(isMobileEnabled() === true) {

            // Hoehenanimation -> auf die Hoehe des Links reduzieren
            if(isMobileEnabled() === true) {
              item.style.maxHeight = (groupContainerLv2.offsetHeight + link.offsetHeight) + 'px';

              setTimeout(function() {
                item.style.maxHeight = link.offsetHeight + 'px';
              }, 0);
            }
          }
        }
      });

      item.addEventListener('navigation.item.deactivated', function(event) {
        link.classList.remove('navigation-item--deactivate');

        if(switchButton !== null) {
          switchButton.classList.remove('navigation__group-switch--deactivate');
        }

        if(groupContainerLv2 !== null) {
          groupContainerLv2.classList.remove('navigation__group-container--lv2-deactivate');
          item.removeAttribute('style'); // Hoehe aus der Animation wieder entfernen
        }
      });
    });
  });
})(window, document);
